import { T, useT } from '@transifex/react';
import { Text, VStack } from '@vidahealth/vida-ui';
import { type Control } from 'react-hook-form';

import { type LegalDocumentGroup } from '@/modules/legalDocuments';
import { CheckboxField } from '@/modules/ui';

import { type AccountFormValues } from '../schema/accountSchema';

import { LegalDocumentCheckbox } from './LegalDocumentCheckbox';

type AgreementsSectionProps = {
  control: Control<AccountFormValues>;
  legalGroups: LegalDocumentGroup[];
  legalError: unknown;
  // SMS opt-in is collected on the normal + PURL forms, not the SSO form.
  showSms?: boolean;
};

// Shared consent block: the per-group legal-document checkboxes (+ a load-error
// message) and the optional SMS opt-in.
export function AgreementsSection({
  control,
  legalGroups,
  legalError,
  showSms = false,
}: AgreementsSectionProps) {
  const t = useT();

  return (
    <VStack space='xl' className='py-2'>
      {legalError != null ? (
        <Text size='sm' className='text-error-700'>
          <T _str='We couldn’t load the required agreements. Please refresh and try again.' />
        </Text>
      ) : null}
      {legalGroups.map((group) => (
        <LegalDocumentCheckbox key={group.anchor.uuid} control={control} group={group} />
      ))}
      {showSms ? (
        <CheckboxField
          control={control}
          name='sms'
          size='sm'
          accessibilityLabel={t('Agree to receive SMS messages from Vida')}
          testID='account-creation-sms-consent'
        >
          <T _str='I agree to receive SMS messages from Vida.' />
        </CheckboxField>
      ) : null}
    </VStack>
  );
}
